import QuizStatuses from '@/constant/QuizStatuses'

// Ordered scored-slide ids up to and including `order`; the last id is the current slide.
export const quizSlideIdsUpTo = (slides, order, isQuizSlide) => {
  if (!slides) return []
  return slides
    .filter((slide) => isQuizSlide(slide) && (order === undefined || slide.order <= order))
    .sort((a, b) => a.order - b.order)
    .map((slide) => Number(slide.id))
}

export const shouldShowLeaderboardAfterQuizWhenPressNext = ({ slide }) => {
  return (
    slide &&
    slide.isLeaderboardEnabled &&
    slide.quizStatus === QuizStatuses.RESULT_SCREEN &&
    slide.type === 'pickAnswer'
  )
}
